import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Container } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import Header from "./components/Header";
import Home from "./pages/Home";
import Article from "./pages/Article";
import Core from "./pages/articles/Core";
import Learning from "./pages/articles/Learning";
import AIFoundations from "./pages/articles/AIFoundations";
import Collaboration from "./pages/articles/Collaboration";
import Agile from "./pages/articles/Agile";
import Security from "./pages/articles/Security";
import Cost from "./pages/articles/Cost";
import Scalability from "./pages/articles/Scalability";
import Documentation from "./pages/articles/Documentation";
import Innovation from "./pages/articles/Innovation";
import theme from './theme';
import About from './pages/About'
import Chat from "./pages/Chat";
import AIParadox from "./pages/opinion/AdoptionParadox";
import AITools from "./pages/opinion/AITools";
import IgnoranceTax from "./pages/opinion/IgnoranceTax";
import Opinion from "./pages/Opinion";
import InspirationLimits from "./pages/opinion/InspirationLimits";
import Momentum from "./pages/opinion/Momentum";
import AIShutdown from "./pages/opinion/AIShutdown";
import CodespaceTemplate from "./pages/opinion/CodespaceTemplate";
import CDU from "./pages/opinion/CDU";

function App() {
  return (
    <ThemeProvider theme={theme}>
    <Router>
      <Header />
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/article" element={<Article />} />
          <Route path="/core" element={<Core />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/ai-foundations" element={<AIFoundations />} />
          <Route path="/collaboration" element={<Collaboration />} />
          <Route path="/agile" element={<Agile />} />
          <Route path="/security" element={<Security />} />
          <Route path="/cost" element={<Cost />} />
          <Route path="/scalability" element={<Scalability />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/opinion" element={<Opinion />} />
          <Route path="/ai-paradox" element={<AIParadox />} />
          <Route path="/ai-tools" element={<AITools />} />
          <Route path="/ignorance-tax" element={<IgnoranceTax />} />
          <Route path="/inspiration-limits" element={<InspirationLimits />} />
          <Route path="/momentum" element={<Momentum />} />
          <Route path="/ai-shutdown" element={<AIShutdown />} />
          <Route path="/codespace-template" element={<CodespaceTemplate />} />
          <Route path="/cdu" element={<CDU />} />
        </Routes>
      </Container>
    </Router>
    </ThemeProvider>
  );
}

export default App;
